<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-form v-model="referenciaForm" ref="form">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <BaseInput class="mb-1" v-model="referencia.nombre" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Nombre completo <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="maskedPhone" v-mask="'###-###-##-##'" maxlength="13" :rules="nameRules">
                <template v-slot:label>Teléfono <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseSelect class="mb-1" v-model="referencia.tipo" :items="tipoReferenciasLaborales">
                <template v-slot:label>Tipo de referencia <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="referencia.cargo" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Cargo que desempeña <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput v-model="referencia.corporacion" :rules="nameRules" validate-on-blur>
                <template v-slot:label>Corporación, Institución o Empresa <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput
                label="Tiempo laborado (años)"
                v-model.number="referencia.tiempoLaborado"
                type="number"
                min="0"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton
        color="secondary"
        class="px-8"
        :disabled="!referenciaForm || loading"
        :loading="loading"
        v-on:click="triggerSaveReferencia()"
        >Guardar</TextButton
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseSelect from '@/components/base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import ReferenciaEntity from '@modules/referencias/domain/ReferenciaEntity'
import { TIPO_REFERENCIAS } from '@src/modules/referencias/domain/TIPO_REFERENCIAS'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },

  props: {
    idPersonal: {
      type: Number,
    },

    referenciaToUpdate: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      referenciaForm: false,
      loading: false,
      referencia: new ReferenciaEntity(),
      maskedPhone: '',
      nameRules: [(v) => !!v || 'Este campo es requerido'],
      tipoReferenciasLaborales: [
        { id: TIPO_REFERENCIAS.COMPAÑEROS_TRABAJO, title: 'Compañeros de trabajo' },
        { id: TIPO_REFERENCIAS.JEFE_ANTERIOR, title: 'Jefe anterior' },
        { id: TIPO_REFERENCIAS.JEFE_INMEDIATO, title: 'Jefe inmediato' },
      ],
    }
  },

  mounted() {
    if (this.referenciaToUpdate) {
      this.referencia = { ...this.referenciaToUpdate }
      this.maskedPhone = this.referencia.telefono.replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '$1-$2-$3-$4')
    }
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapActions('referenciaEnlaceC3', ['createReferencia', 'updateReferencia', 'fetchReferenciasByPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerSaveReferencia() {
      try {
        this.loading = true
        this.referencia.telefono = this.maskedPhone.replace(/-/g, '')

        if (this.referenciaToUpdate) {
          await this.updateReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        } else {
          await this.createReferencia({ idPersonal: this.idPersonal, referencia: this.referencia })
        }

        this.resetForm()
        this.closeDialog()
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al registrar la referencia.')
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.referencia = new ReferenciaEntity()
      this.maskedPhone = ''
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
  },
}
</script>
